(() => {
const allowed = button => {
const notice = button?.closest('.cart__ctas')?.querySelector('ch-shipping-notice');
if (!notice) return true;
const checkbox = notice.querySelector('[data-shipping-ack]');
if (checkbox?.checked) return true;
checkbox?.focus(); checkbox?.reportValidity(); return false;
};
class ShippingNotice extends HTMLElement {
connectedCallback() {
if (this.ready) return;
this.ready = true;
const checkbox = this.querySelector('[data-shipping-ack]');
const button = this.closest('.cart__ctas')?.querySelector('[name="checkout"]');
if (!checkbox || !button) return;
const update = () => { button.disabled = !checkbox.checked; };
checkbox.addEventListener('change', update); update();
}
}
document.addEventListener('click', event => {
const button = event.target.closest?.('[name="checkout"]');
if (button && !allowed(button)) { event.preventDefault(); event.stopImmediatePropagation(); }
}, true);
document.addEventListener('submit', event => {
if (event.submitter?.name === 'checkout' && !allowed(event.submitter)) { event.preventDefault(); event.stopImmediatePropagation(); }
}, true);
if (!customElements.get('ch-shipping-notice')) customElements.define('ch-shipping-notice', ShippingNotice);
})();